import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { getVacationLeave } from '../../../services/ApiGetVacationLeave';
import { useTranslation } from 'react-i18next';
import Moment from 'moment';
import { VacationLeave } from '../../../model/datatype';

export const TimeVacationLeave = (props: any) => {
  let { t } = useTranslation();
  const [data, setData] = useState<VacationLeave | null>(null);

  useEffect(() => {
    if (data === null) {
      getVacationLeave(0, 0,props.email).then((response: any) => {
        const getData: any = response;
        setData(getData);
      });
    }
  }, [data]);

  // console.log('TimeVacationLeave=',data);

  return (
    <div className="TimeInout_ThisWeek_detail text-center">
      <Row className="m-auto">
        <Col className="px-1">
          <div className="time_late_this_week_detail_box">
            <div className="Time_vacation_ThisWeek_detail_text">
              {t('time_list_box.timeanddate_vacation_leave.title')}
            </div>
            <Row className="vacation-this-week-title-box m-1">
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_vacation_leave.date')}
              </Col>
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_vacation_leave.hour')}
              </Col>
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_vacation_leave.remark')}
              </Col>
            </Row>
            <div className="w-100 table-container">
              {typeof data?.leaveDetailsInfos !== 'undefined' ? (
                data?.leaveDetailsInfos.length > 0 ? (
                  data?.leaveDetailsInfos.map((item: any, index: number) => (
                    <Row
                      className="late_time-in-out-list  m-1 mt-3"
                      key={index}
                    >
                      <Col className="late_this-week-title-val px-1 text-center">
                        {Moment(item.dateWork).format('DD/M/YYYY')}
                      </Col>
                      <Col className="late_this-week-title-val px-1 text-center">
                        {item.qtyStr}{' '}
                        {t('time_list_box.timeanddate_vacation_leave.hour')}
                      </Col>
                      <Col className="late_this-week-title-val">
                        {localStorage.getItem('Language') === 'th'
                          ? item.descriptionTH
                          : item.descriptionEN}
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="loader-data text-notfound">
                    {t('text_notfound')}
                  </div>
                )
              ) : (
                <div className="loader-data">
                  <div className="spinner"></div>
                </div>
              )}
            </div>
            <Row className="late_time-in-out-list line-total m-1 mt-3">
              <Col xs={4} className="this-week-title-val px-1 text-center">
                <strong className="vacation-time-in-out-this-week-total">
                  {t('time_list_box.timeanddate_vacation_leave.total')}
                </strong>
              </Col>
              <Col xs={8} className="this-week-title-val px-1 text-right">
                <strong className="vacation-time-in-out-this-week-total">
                  {data?.summaryUsed}{' '}
                  {t('time_list_box.timeanddate_vacation_leave.unit')}
                </strong>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="m-2"></Col>
      </Row>
    </div>
  );
};
